import RootOutlet from "@components/RootOutlet"
import DownloadRedirectPage from "@pages/DownloadRedirectPage"
import ErrorPage from "@pages/ErrorPage"
import { Navigate, Outlet } from "react-router-dom"
import accountRoutes from "./account/accountRoutes"
import checkoutRoutes from "./checkout/checkoutRoutes"
import helpCenterRoutes from "./helpCenter/helpCenterRoutes"
import onboardingCarsRoutes from "./onboarding/cars/onboardingCarsRoutes"
import onboardingHairstyleRoutes from "./onboarding/hairstyle/onboardingHairstyleRoutes"
import onboardingHomeRoutes from "./onboarding/home/onboardingHomeRoutes"
import onboardingLooksmaxxingRoutes from "./onboarding/looksmaxxing/onboardingLooksmaxxingRoutes"
import onboardingRoutes from "./onboarding/onboardingRoutes"
import onboardingPetsRoutes from "./onboarding/pets/onboardingPetsRoutes"
import onboardingRoutesV1 from "./onboarding/v1/onboardingRoutesV1"
import onboardingRoutesV3 from "./onboarding/v3/onboardingRoutesV3"
import signUpRoutes from "./signUp/signUpRoutes"

const routes = [
  {
    element: <RootOutlet />,
    errorElement: <ErrorPage />,
    path: "/",
    children: [
      {
        element: <Navigate to="onboarding" replace />,
        index: true,
      },
      {
        element: <Outlet />,
        path: "account",
        children: accountRoutes,
      },
      {
        element: <Outlet />,
        path: "checkout",
        children: checkoutRoutes,
      },
      {
        element: <Outlet />,
        path: "help-center",
        children: helpCenterRoutes,
      },
      {
        element: <Outlet />,
        path: "onboarding",
        children: onboardingRoutes,
      },
      ...onboardingCarsRoutes,
      ...onboardingHairstyleRoutes,
      ...onboardingHomeRoutes,
      ...onboardingLooksmaxxingRoutes,
      ...onboardingPetsRoutes,
      ...onboardingRoutesV1,
      ...onboardingRoutesV3,
      {
        element: <Navigate to="/onboarding/cars" replace />,
        path: "cars",
      },
      {
        element: <Navigate to="/onboarding/home" replace />,
        path: "home",
      },
      {
        element: <Navigate to="/onboarding/hairstyle" replace />,
        path: "hairstyle",
      },
      {
        element: <Navigate to="/onboarding/looksmaxxing" replace />,
        path: "looksmaxxing",
      },
      {
        element: <Navigate to="/onboarding/pets" replace />,
        path: "pets",
      },
      {
        element: <Outlet />,
        path: "sign-up",
        children: signUpRoutes,
      },
      {
        element: <DownloadRedirectPage />,
        path: "download",
      },
      {
        element: <Navigate to="/onboarding" replace />,
        path: "*",
      },
    ],
  },
]

export default routes
